import React from 'react'

function IconCloseNormal() {
  return (
    <svg className="icon icon--close">
      <use xlinkHref="#icon-close" />
    </svg>
  )
}

export default IconCloseNormal
